export function getTextUnderlineOffset(transformer) {
    return Object.freeze({
        m: transformer.textUnderlineOffset('2px'),
        l: transformer.textUnderlineOffset('4px'),
    });
}
